import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

export type DonateFreq = 'one-time' | 'monthly'

interface DonateState {
  amount: number
  frequency: DonateFreq
  setAmount: (n: number) => void
  setFrequency: (f: DonateFreq) => void
  reset: () => void
}

export const useDonateStore = create<DonateState>()(
  persist(
    (set) => ({
      amount: 50,
      frequency: 'one-time',
      setAmount: (amount) => set({ amount }),
      setFrequency: (frequency) => set({ frequency }),
      reset: () => set({ amount: 50, frequency: 'one-time' }),
    }),
    { name: 'cosmos-donate', storage: createJSONStorage(() => sessionStorage) }
  )
)
